import React, { useEffect, useState } from "react";
import Swal from "sweetalert2";

const ResizeWebsite = () => {
  const [hasShown, setHasShown] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      const width = window.innerWidth;
      if (width <= 620 && !hasShown) {
        Swal.fire({
          title: "Download Our App",
          text: "For a better experience, please download our app from Play Store or App Store.",
          icon: "info",
          showCancelButton: true,
          confirmButtonText: "Play Store",
          cancelButtonText: "App Store",
          confirmButtonColor: "#34a853",
          cancelButtonColor: "#0070c9",
        }).then((result) => {
          if (result.isConfirmed) {
           // window.open("https://play.google.com/store", "_blank");
             window.open("https://play.google.com/store/apps/details?id=com.ktmedu_mark&pcampaignid=web_share", "_blank");
          } else if (result.dismiss === Swal.DismissReason.cancel) {
            window.open("https://play.google.com/store/apps/details?id=com.ktmedu_mark&pcampaignid=web_share", "_blank");
          }
        });

        setHasShown(true); // Prevents it from showing again
      }
    };

    // Trigger on initial load and on resize
    handleResize();
    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, [hasShown]);

  return null; // This component renders nothing visually
};

export default ResizeWebsite;
